import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

type PropTypes = {
  matchesAvailable: number;
};
export const BannerAvailableMatches = ({ matchesAvailable }: PropTypes) => {
  return (
    <Typography
      variant="h6"
      display="inline"
      sx={{
        textAlign: 'center',
        marginLeft: '4px',
        background: matchesAvailable
          ? 'linear-gradient(106deg, rgb(30 30 30) 0%, rgb(29 146 4) 50%, rgb(30 30 30) 100%)'
          : 'linear-gradient(106deg, rgb(30 30 30) 0%, rgba(136,70,70,1) 50%, rgb(30 30 30) 100%)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 3,
      }}
    >
      {!matchesAvailable ? (
        <Tooltip
          title={
            'Matches will be available when players within your MMR range seed more games'
          }
          placement="top"
        >
          <InfoIcon
            sx={{
              color: '#ec7373',
              mr: 2,
            }}
          />
        </Tooltip>
      ) : (
        <Tooltip
          title={
            'MMRs are snapshotted for seeded games. So you might be matched against an opponent that has moved out of your MMR range since the seeding'
          }
          placement="top"
        >
          <InfoIcon
            sx={{
              color: '#96ff7f',
              mr: 1,
            }}
          />
        </Tooltip>
      )}
      There {matchesAvailable === 1 ? 'is' : 'are'}{' '}
      <Typography
        variant="h6"
        display="inline"
        fontWeight={600}
        color={matchesAvailable ? 'success.main' : 'warning.main'}
        mx={1}
      >
        {matchesAvailable}
      </Typography>{' '}
      match{matchesAvailable === 1 ? '' : 'es'} available
    </Typography>
  );
};
